import { CheckoutPaymentFormData } from '../types'

import { PaymentInteractor } from './services'
import { PaymentProcessorsMethodsType } from './types'

export default class PaymentProcessors {
  constructor(
    private payments: Record<PaymentProcessorsMethodsType, PaymentInteractor>
  ) {
    this.payments = payments
  }

  public async checkout(data: CheckoutPaymentFormData) {
    return await this.payments[
      data.paymentMethod as PaymentProcessorsMethodsType
    ].checkout(data)
  }
}
